var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-content"},[(_vm.showIntro)?_c('div',{ref:"intro"},[_c('intro',{ref:"intro",on:{"ended":_vm.toggleIntro}})],1):_vm._e(),_c('rapport'),_c('numbers'),_c('quiz'),_c('results')],1)}
var staticRenderFns = []

export { render, staticRenderFns }